import React from "react";
import { Navigate } from "react-router-dom";
import ProfileForm from "components/Forms/Multistep/ProfileCompletion/ProfileForm";
import { useContext } from "react";
import AuthContext from "context/AuthContext";
import StoreProfileForm from "components/Forms/Multistep/ProfileStore/StoreProfileForm";
import AdminProfileController from "components/Forms/Multistep/ProfileAdmin/AdminProfileController";
import AdminRoleProfileForm from "components/Forms/Multistep/ProfileStore/AdminRoleProfileForm";
import PurebrandLoader from "components/Loader/PurebrandLoader";
import useCan from "hooks/useCan";
import { ROLES } from "utils/constants";

const Host = () => {
  let { user, userProfile, profileLoading, emailVerificationLoading } = useContext(AuthContext);
  const { isStoreUser } = useCan();

  if (profileLoading || emailVerificationLoading || !userProfile) {
    return <PurebrandLoader />;
  }

  if (userProfile?.complete_profile) {
    return <Navigate to="/user/welcome" />;
  }
  if (user.role === ROLES.HOST.role) {
    return (
      <>
        <div className="host-homepage">
          <ProfileForm />
        </div>
      </>
    );
  } else if (user.role === ROLES.STORE_ADMIN.role) {
    return (
      <>
        <div className="host-homepage">
          <StoreProfileForm />
        </div>
      </>
    );
  } else if (isStoreUser) {
    return (
      <>
        <div className="host-homepage">
          <AdminRoleProfileForm />
        </div>
      </>
    );
  } else if (user.role === ROLES.PUREBRAND_ADMIN.role) {
    return (
      <>
        <div className="host-homepage">
          <AdminProfileController />
        </div>
      </>
    );
  }
};

export default Host;
